// EU-27 + EEA-3 (Iceland, Liechtenstein, Norway) + UK = 31 codes
const EU_EEA_COUNTRIES = new Set([
	"AT",
	"BE",
	"BG",
	"HR",
	"CY",
	"CZ",
	"DK",
	"EE",
	"FI",
	"FR",
	"DE",
	"GR",
	"HU",
	"IE",
	"IT",
	"LV",
	"LT",
	"LU",
	"MT",
	"NL",
	"PL",
	"PT",
	"RO",
	"SK",
	"SI",
	"ES",
	"SE",
	"IS",
	"LI",
	"NO",
	"GB",
]);

export function isEuCountry(code: string): boolean {
	return EU_EEA_COUNTRIES.has(code.toUpperCase());
}
